import { Entity } from '@debbie/common/dist/index.js';
import { Direction, } from '@debbie/common/dist/interactions/index.js';
import { replyRecipient, replySubject, } from '@debbie/common/dist/interactions/reply.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { Email, Modal, Panel } from '../index.js';
import EmailInteraction from '../interactions/EmailInteraction.js';
import EmailThread from '../threads/EmailThread.js';
import DefaultSummary from './DefaultSummary.js';
const EmailSummary = (props) => {
    const lang = useSelector((s) => s.lang);
    const metaData = [
        ...(props.interaction.details.from
            ? [
                {
                    header: lang.interactions.from,
                    body: props.interaction.direction === Direction.INCOMING ? (React.createElement("b", null, props.interaction.details.from)) : (props.interaction.details.from),
                },
            ]
            : []),
        ...(props.interaction.details.to
            ? [
                {
                    header: lang.interactions.to,
                    body: props.interaction.direction === Direction.OUTGOING ? (React.createElement("b", null, props.interaction.details.to)) : (props.interaction.details.to),
                },
            ]
            : []),
        ...(props.interaction.details.cc
            ? [{ header: 'CC', body: props.interaction.details.cc }]
            : []),
        ...(props.interaction.details.bcc
            ? [{ header: 'BCC', body: props.interaction.details.bcc }]
            : []),
        ...(props.interaction.details.replyTo
            ? [{ header: 'Reply To', body: props.interaction.details.replyTo }]
            : []),
        ...(props.interaction.details.subject
            ? [
                {
                    header: lang.interactions.subject,
                    body: React.createElement("b", null, props.interaction.details.subject),
                },
            ]
            : []),
    ];
    return (React.createElement(DefaultSummary, { ...props, metaData: metaData },
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement(Email, { interaction: props.interaction, noToggle: props.alwaysExtended }),
            React.createElement("br", null),
            props.replying && (React.createElement(Modal, { header: lang.interactions.reply, onToggle: () => {
                    if (props.setReplying) {
                        props.setReplying(false);
                    }
                } },
                React.createElement(Wrapper, null,
                    React.createElement(Panel, null,
                        React.createElement(EmailInteraction, { referenceId: props.interaction.referenceId, referenceType: props.interaction.referenceType || Entity.Case, emailTo: replyRecipient(props.interaction.details), emailToEditable: true, replyingToInteractionId: props.interaction.id, defaultSubject: replySubject(props.interaction.details.subject, lang.interactions.replyPrefix || 'Re:'), onSent: () => {
                                if (props.setReplying) {
                                    props.setReplying(false);
                                }
                            } })),
                    React.createElement(Panel, { header: lang.interactions.replyingTo },
                        React.createElement(Email, { interaction: props.interaction }))))),
            props.showThread && props.longCaseId && (React.createElement(Modal, { header: lang.interactions.emailThread, onToggle: () => {
                    if (props.setShowThread) {
                        props.setShowThread(false);
                    }
                } },
                React.createElement(EmailThread, { caseId: props.longCaseId, referenceInteraction: props.interaction.id }))))));
};
const Wrapper = styled.div `
  background: ${THEME.BACKGROUND};
`;
export default EmailSummary;
//# sourceMappingURL=EmailSummary.js.map